import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import SearchResultCard from '../components/SearchResultCard';
import '../styles/SearchPage.css';

const MIN_QUERY_LENGTH = 2;

const SearchPage = ({ apiBaseUrl }) => {
  const location = useLocation();
  const [query, setQuery] = useState(() => new URLSearchParams(location.search).get('q') || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const debounceRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    const trimmed = query.trim();
    if (trimmed.length < MIN_QUERY_LENGTH) {
      setResults([]);
      setHasSearched(false);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    debounceRef.current = setTimeout(() => {
      fetch(`${apiBaseUrl}/search?q=${encodeURIComponent(trimmed)}`, { credentials: 'include' })
        .then(res => res.json())
        .then(data => {
          setResults(data);
          setHasSearched(true);
        })
        .catch(err => console.error('Error fetching search results:', err))
        .finally(() => setLoading(false));
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [query, apiBaseUrl]);

  return (
    <div className="search-page">
      <Helmet>
        <title>Search - Y02 Media Database</title>
      </Helmet>

      <div className="search-page-hero">
        <h1>Search everything</h1>
        <p className="search-page-subtitle">
          Titles, genres, studios, cast, tags, IDs, achievements &amp; more.
        </p>
        <div className="advanced-search-input-wrapper">
          <img src="/static/icons/magnifying-glass-solid.svg" className="search-icon icon" alt="" />
          <input
            ref={inputRef}
            type="text"
            className="advanced-search-input"
            placeholder="Search for anything..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>

      {loading && <p className="search-page-status">Searching…</p>}

      {!loading && hasSearched && results.length === 0 && (
        <p className="search-page-status">No matches found for “{query.trim()}”.</p>
      )}

      {!loading && results.length > 0 && (
        <div className="search-results-grid">
          {results.map((item) => (
            <SearchResultCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchPage;
